import React, { Component } from 'react';
import { DetailsListGrilleDePrix } from '../List/DetailsListGrilleDePrix';

export class GrilleDePrix extends Component {

    render = () => <DetailsListGrilleDePrix />;

}